import React, { memo, useCallback } from 'react';
import type { CSSProperties } from 'react';
import { mapOptionsListStyleToCSS } from '../../../../utils/styleMapper';
import { CheckBox } from '../../CheckBox';
import { OptionsItemText } from '../OptionsItemText';
import type { OptionsItemVariantProps } from './types';
import { getOptionItemA11yProps } from '../../../../utils/optionItemA11y';
import styles from '../OptionsItem.module.css';

export const CheckboxTitle = memo(function CheckboxTitle({
  item,
  index,
  locale,
  variables,
  selectable,
  selected,
  disabled,
  selectionMode,
  appearance,
  selectedAppearance,
  onSelect,
  className,
  style,
  'data-testid': testId,
  editPath,
}: OptionsItemVariantProps): React.ReactElement {
  const handleClick = useCallback(() => {
    if (selectable && !disabled && onSelect) {
      onSelect(item, index, !selected);
    }
  }, [selectable, disabled, onSelect, item, index, selected]);

  const activeStyle = selected ? selectedAppearance : appearance;
  const itemStyle: CSSProperties = mapOptionsListStyleToCSS(activeStyle);

  return (
    <div
      className={`${styles.listItem}${selected ? ` ${styles.selected}` : ''}${disabled ? ` ${styles.disabled}` : ''}${className ? ` ${className}` : ''}`}
      style={style ? { ...itemStyle, ...style } : itemStyle}
      onClick={selectable && !disabled ? handleClick : undefined}
      {...getOptionItemA11yProps({ selectable, selected, disabled, selectionMode, onActivate: handleClick })}
      data-testid={testId}
      data-edit-path={editPath}
    >
      <div className={styles.checkbox}>
        <CheckBox toggleMark={item.checkbox} />
      </div>
      <div className={styles.content}>
        <OptionsItemText label={item.title} locale={locale} variables={variables} editPath={editPath ? `${editPath}.title` : undefined} />
      </div>
    </div>
  );
});

CheckboxTitle.displayName = 'CheckboxTitle';
